"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resource = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class Resource {
    /**
     *Creates an instance of Resource.
     * @memberof Resource
     */
    constructor() {
        if (!(authData_1.Auth.getUserToken() && authData_1.Auth.getDomainToken())) {
            throw new Error("Cannot use Node service without authenticated user and opened domain!, " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    create(resource) {
        return this.api.post("resource", resource);
    }
    createSimple(resource) {
        return this.api.post("resource/createSimple", resource);
    }
    upload(data, onUploadProgress) {
        return this.api.uploadFile("resource", data, onUploadProgress);
    }
    createFromGDoc(doc, onUploadProgress) {
        return this.api.uploadFile("resource/createGDoc", doc, onUploadProgress);
    }
    getAll() {
        return this.api.getAll("resource");
    }
    get(resourceId) {
        return this.api.get(`resource/${resourceId}`);
    }
    getMany(resourceIds) {
        return this.api.getSearchQuery("resource", { where: { id: resourceIds } });
    }
    delete(resourceId) {
        return this.api.delete(`resource/${resourceId}`);
    }
    getResourceTypes() {
        return this.api.get(`type/resources`);
    }
    query(query) {
        return this.api.postSearchQuery("resource", query);
    }
    update(resource) {
        return this.api.put(`resource/${resource.id}`, resource);
    }
    addResourceToNode(node, resource) {
        return this.api.post(`resourcemapping`, {
            node: node.id,
            resource: resource.id
        });
    }
    removeResourceMapping(resourceMapping) {
        const mappingId = (typeof resourceMapping === 'number') ? resourceMapping : resourceMapping.id;
        return this.api.delete(`resourcemapping/${mappingId}`);
    }
    addToNode(node, resources) {
        return this.api.postMany(`resourcemapping/create`, resources.map(r => ({ node: node.id, resource: r.id })));
    }
    // deprecated - removed
    // public createResourceMapping(mapping: iResourceMapping): Promise<iResourceMapping> {
    //   return this.api.post<iResourceMapping>(`resourcemapping/create`, mapping);
    // }
    createResourceMappings(mappings) {
        return this.api.postMany(`resourcemapping/many`, mappings);
    }
    /**
     * @param {object} query: Query Language Basics, @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language
     * @returns {Promise<iResourceMapping[]>}
     */
    getResourceMappings(query) {
        return this.api.getAll("resourcemapping", query);
    }
    getSignedUrl(param) {
        return this.api.post(`resource/signedurl`, param);
    }
}
exports.Resource = Resource;
//# sourceMappingURL=data:application/json;base64,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